<script setup lang="ts">
import { i18n } from '@apps/main/modules/localization/localizationSetup';
import {
  ItinerarySegmentPlaceholder,
  ItinerarySegmentPlaceholderType,
} from '@apps/main/new-desktop/modules/itineraryButton';

import { AppSingleSelect } from '@libs/ui';

import type { UnavailableItineraryActivitySegment } from '../../../models';
import ItineraryTimeline from '../ItineraryTimeline.vue';

import UnavailableActivityProduct from './UnavailableActivityProduct.vue';
import ActivityCardHeader from './ActivityCardHeader.vue';

const { t } = i18n.global;

interface UnavailableActivitySegmentProps {
  segment: UnavailableItineraryActivitySegment;
  unavailabilityMessage: string;
  printMode: boolean;
  shouldHideProductLink: boolean;
}

const props = defineProps<UnavailableActivitySegmentProps>();

interface UnavailableActivitySegmentEmits {
  (eventName: 'edit-filters'): void;
  (eventName: 'remove-activity'): void;
  (eventName: 'try-another-date'): void;
}

const emit = defineEmits<UnavailableActivitySegmentEmits>();
</script>

<template>
  <ItineraryTimeline
    :segment-type="props.segment.segmentType"
    class="unavailable-activity-segment"
  >
    <template #dropdown>
      <AppSingleSelect
        v-if="!props.shouldHideProductLink"
        type="primary"
        :selected="{
          id: 1,
          label: t('planner.activity'),
          icon: 'activity',
        }"
        left-side-icon="activity"
        :options="[]"
        disabled
      />
      <ItinerarySegmentPlaceholder
        v-else
        :transport-type="ItinerarySegmentPlaceholderType.Activity"
      />
    </template>
    <template #header>
      <ActivityCardHeader
        :print-mode="props.printMode"
        @remove="emit('remove-activity')"
      />
    </template>

    <template #content>
      <UnavailableActivityProduct
        :should-hide-product-link="shouldHideProductLink"
        :reasons="props.segment.reasons"
        :message="props.unavailabilityMessage"
        :ingredient-index="props.segment.context.ingredientIndex"
        @edit-filters="emit('edit-filters')"
        @try-another-date="emit('try-another-date')"
      />
    </template>
  </ItineraryTimeline>
</template>
